"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COEFFICIENT_B = exports.COEFFICIENT_A = void 0;
exports.COEFFICIENT_A = 5.957897657;
exports.COEFFICIENT_B = 0.603614753;
//# sourceMappingURL=coefficients.js.map